import React from "react";
import UploadImage from "../../FormFields/UploadImage";

const MessageA21I = (props) => {
  return <UploadImage {...props} />;
};

export default MessageA21I;
